let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <deliveryOrder>
        <deliveryOrderCode>销售单号, string (50) , 必填</deliveryOrderCode>
        <deliveryOrderId>仓储系统销售出库单号, string (50) , 条件必填</deliveryOrderId>
        <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
        <ownerCode>货主编码, string (50), 必填</ownerCode> 
        <orderType>销售订单类型, string (50), 例如: XSDD=销售订单, DBCK=调拨出库、CGTH=采购退货, QTCK=其他出库, 必填</orderType>
        <status>销售单状态, string (50), NEW=未开始处理, ACCEPT=仓库接单, PARTDELIVERED=部分发货完成, DELIVERED=发货完成, CANCELED=取消, CLOSED=关闭, CANCELEDFAIL=取消失败(只传英文编码)</status>
        <outBizCode>外部业务编码, string (50), 消息ID, 用于去重, 因为网络等原因导致重复传输, 请求不会被重复处理。一单需要多次确认时条件必填</outBizCode>
        <confirmType>支持多次发货, int, 多次发货确认时, 0=发货单最终状态确认: 1=发货单中间状态确认</confirmType>
        <deliveryTime>完成时间, string (19), YYYY-MM-DD HH:MM:SS,为空时WMS自动生成</deliveryTime>
        <logisticsCode>物流公司编码, string (50), SF=顺丰、EMS=标准快递、EYB=经济快件、ZJS=宅急送、YTO=圆通、ZTO=中通、HTKY=百世汇通、UC=优速、STO=申通、TTKDEX=天天快递、QFKD=全峰、FAST=快捷、POSTB=邮政小包、GTO=国通、YUNDA=韵达、JD=京东配送、DD=当当宅配、AMAZON=亚马逊物流、OTHER=其他(只传英文编码)</logisticsCode>
        <expressCode>运单号, string (50)</expressCode>
        <shipper>发货人, string (50)</shipper>
        <customer>客户名称, string (50)</customer>
        <documentMaker>制单人, string (50) 默认为openapi</documentMaker>
        <userDefined1>自定义1, string (50)</userDefined1>
        <userDefined2>自定义2, string (50)</userDefined2>
        <userDefined3>自定义3, string (50)</userDefined3>
        <userDefined4>自定义4, string (50)</userDefined4>
    </deliveryOrder>
    <packages>
        <package>
            <logisticsCode>物流公司编码, string (50), SF=顺丰、EMS=标准快递、EYB=经济快件、ZJS=宅急送、YTO=圆通、ZTO=中通、HTKY=百世汇通、UC=优速、STO=申通、TTKDEX=天天快递、QFKD=全峰、FAST=快捷、POSTB=邮政小包、GTO=国通、YUNDA=韵达、JD=京东配送、DD=当当宅配、AMAZON=亚马逊物流、OTHER=其他(只传英文编码)</logisticsCode>
            <expressCode>运单号, string (50)</expressCode>
            <packageCode>箱号, string (50)</packageCode>
            <items>
                <item>
                    <itemCode>商品编码, string (50), 必填</itemCode>
                    <quantity>箱内该商品的数量, float, 必填</quantity>
                </item>
            </items>
            <weight>箱重量, double (18, 3)</weight>
            <volume>箱体积, double (18, 3)</volume>
            <consumableVolume>耗材体积, double (18, 3)</consumableVolume>
            <consumableCode>耗材编码, string (50)</consumableCode>
            <productVolume>货品体积, double (18, 3)</productVolume>
            <productWeight>货品重量, double (18, 3)</productWeight>
            <userDefined1>箱自定义1, string (50)</userDefined1>
            <userDefined2>箱自定义2, string (50)</userDefined2>
            <userDefined3>箱自定义3, string (50)</userDefined3>
            <userDefined4>箱自定义4, string (50)</userDefined4>
        </package>
    </packages>
    <orderLines>
        <orderLine>
            <lineNo>行号, int</lineNo>    
            <itemCode>商品编码, string (50), 必填</itemCode>
            <actualQty>实发商品数量, float, 必填</actualQty>
            <inventoryType>质量状态, string (50), ZP=正品, CC=残次, 默认为ZP</inventoryType>
            <customField1>自定义字段1, string (50)</customField1>
            <customField2>自定义字段2, string (50)</customField2>
            <customField3>自定义字段3, string (50)</customField3>
            <customField4>自定义字段4, string (50)</customField4>
            <customField5>自定义字段5, string (50)</customField5>
            <customField6>自定义字段6, string (50)</customField6>
            <customField7>自定义字段7, string (50)</customField7>
            <customField8>自定义字段8, string (50)</customField8>
        </orderLine>
    </orderLines>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`
let NotificaitonURL = 'NotificaitonURL'

export default { xmlRequest, xmlResponse, NotificaitonURL }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.saleorder.confirm.js